import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export function BackButton() {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  return (
    <Button
      variant='link'
      className='text-foreground mb-6 bg-transparent font-medium hover:bg-transparent'
      onClick={() => navigate(-1)}
    >
      <ArrowLeft size={16} />
      {t('back')}
    </Button>
  );
}
